<template>
    <div class="k-control-overlay">
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
</script>

<style lang="scss">
.k-control-overlay {
    position: absolute;
    left: 0;
    top: 0;
    top: calc(0px + env(safe-area-inset-top));
    width: 100%;
    height: 100%;
    max-height: calc(100% - (env(safe-area-inset-bottom) + env(safe-area-inset-top)));
    z-index: 1000;
    pointer-events: none;
}
</style>